 
import { Stack } from '@mui/material'; 
import CreateReport from './components/CreateReport'; 
import { ReportsBuilderProvider } from './context/ReportsBuilderContext';
import PageArea from '../../components/shared/PageArea';
import Filter from './components/Filters';
import ReportBuilderPopUps from './components/ReportBuilderPopUps';
import FieldSelector from './components/FieldSelector';
import DataGroupSelector from './components/DataGroupSelector';

const ReportsPage = () => { 
  return (
    <ReportsBuilderProvider>
      <PageArea>
        <Stack spacing={5}>
          <CreateReport/>
          <DataGroupSelector/>
          <Filter/>
          <FieldSelector/>
        </Stack>
      </PageArea>
      <ReportBuilderPopUps/>
    </ReportsBuilderProvider>
  );
};

export default ReportsPage;
